import * as React from 'react';
export var NaviContext = React.createContext({});
export var NavConsumer = NaviContext.Consumer;
export var NavContextProvider = NaviContext.Provider;
//# sourceMappingURL=NaviContext.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-navi/dist/es/NaviContext.js
// module id = 13
// module chunks = 0